import { useTranslation } from 'react-i18next';
import { useKronerInput } from '../../../hooks/useKronerInput';
import { getDkkSymbol } from '../../../utils/currencyUtils';
import styles from './CompletionAmountField.module.css';

interface CompletionAmountFieldProps {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
}

// Plan-level amount the government pays once per patient when their treatment on the plan
// ends. An empty field means the plan has no completion reimbursement at all — a plain input
// (like the group reimbursement field) because the library number field cannot stay empty:
// it coerces a cleared value to 0 on blur, which would silently save "pays 0 kr" instead.
// Government tariffs carry øre, so this field accepts two decimal places.
export const CompletionAmountField = ({ value, onChange }: CompletionAmountFieldProps) => {
  const { t, i18n } = useTranslation();
  const { text, handleChange, handleBlur, handleKeyDown } = useKronerInput(value, onChange, {
    maxDecimals: 2,
    allowZero: false
  });

  return (
    <div className={styles.field}>
      <span className={styles.fieldLabel}>{t('config-builder-completion-amount')}</span>
      <div className={styles.inputWrapper}>
        <input
          type="number"
          className={styles.input}
          value={text}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          min={500}
          step={500}
          aria-label={t('config-builder-completion-amount')}
        />
        <span className={styles.suffix} aria-hidden="true">
          {getDkkSymbol(i18n.language)}
        </span>
      </div>
    </div>
  );
};
